module.exports = __webpack_public_path__ + "img/ebook-shopping-mall-bg.4dea6599.webp";